import { Condition } from '@staffino/model';
import { ConditionEvaluatorContext } from '../condition-evaluator-context';

export default async function legacyParameter(
  condition: Condition,
  context: ConditionEvaluatorContext,
): Promise<boolean> {
  const { name, value } = condition[1];
  const parameterValue = context.bridge.parameters?.[name];
  return parameterValue === value; // TODO: add operation (default ==)
}
